/* =========================================================
   Southern Made – bulk order limit
   Sends shoppers to the bulk order page instead of adding to cart
   or checking out when the cart goes over the limit (e.g. 144).
   Config comes from the "SM Bulk order limit" section.
   ========================================================= */
(function () {
  if (window.SmBulkLimit) return;
  var el = document.getElementById('SmBulkLimitConfig');
  if (!el) return;
  var cfg;
  try { cfg = JSON.parse(el.textContent); } catch (e) { return; }
  if (!cfg.enabled || !cfg.url) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var origFetch = window.fetch.bind(window);
  var cart = { item_count: cfg.cartCount || 0, items: [] };
  var redirecting = false;

  var ADD_SELECTOR = [
    '.tee-btn--atc', '#teeAtcButton',                         // TeeInBlue
    'button[name="add"]', '.ProductForm__AddToCart',          // theme
    '.shopify-payment-button__button', '.shopify-payment-button button', // Buy it now
    '.shopify-payment-button', 'shopify-accelerated-checkout', 'shopify-buy-it-now-button', 'shop-pay-wallet-button',
    '[data-sm-quick-add]'                                     // SM quick add
  ].join(',');
  var PAY_SELECTOR = '.shopify-payment-button, shopify-accelerated-checkout, shopify-buy-it-now-button';
  var CHECKOUT_SELECTOR = [
    'button[name="checkout"]', 'input[name="checkout"]', 'a[href$="/checkout"]', 'a[href*="/checkout?"]',
    '.additional-checkout-buttons button', 'shop-pay-wallet-button', '.Cart__Checkout', '[data-checkout-button]'
  ].join(',');

  window.SmBulkLimit = { config: cfg, cart: function () { return cart; } };

  function productQty(productId) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (String(it.product_id) === String(productId)) n += it.quantity; });
    return n;
  }
  function isOver(n) { return n > cfg.limit; }

  function go(total, productId) {
    if (redirecting) return;
    redirecting = true;
    var u = new URL(cfg.url, window.location.origin);
    if (cfg.passDetails) {
      u.searchParams.set('quantity', total);
      if (cfg.productTitle && (!productId || String(productId) === String(cfg.productId))) u.searchParams.set('product', cfg.productTitle);
      u.searchParams.set('reason', 'bulk');
    }
    window.location.href = u.toString();
  }

  function refresh() {
    return origFetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { cart = c; return c; })
      .catch(function () { return cart; });
  }

  /* quantity being added by a clicked button.
     The theme's quantity box is often OUTSIDE the add to cart form (linked with form="…"),
     so look in: the button's form → inputs linked to that form → the product section. */
  function qtyInput(el) {
    var tee = el.closest('.tee-campaign');
    if (tee) { var ti = tee.querySelector('.tee-quantity-input'); if (ti) return ti; }
    var form = el.form || el.closest('form');
    if (form) {
      var inForm = form.querySelector('input[name="quantity"]');
      if (inForm) return inForm;
      if (form.id) {
        var linked = document.querySelector('input[name="quantity"][form="' + form.id + '"]');
        if (linked) return linked;
      }
    }
    var scope = el.closest('.SmCard, .ProductSummary, .Product, section-product, .shopify-section') || document;
    return scope.querySelector('.Product__Block--quantitySelector input, input[name="quantity"], .tee-quantity-input');
  }
  function readQty(btn) {
    if (btn.hasAttribute && btn.hasAttribute('data-sm-quick-add')) return 1;
    var input = qtyInput(btn);
    var n = input ? parseInt(input.value, 10) : 1;
    return isNaN(n) || n < 1 ? 1 : n;
  }
  function readProductId(btn) {
    if (btn.hasAttribute('data-sm-quick-add')) return null; // other product from a card
    return cfg.productId || null;
  }

  /* 1. Block "add to cart" before it happens */
  function addButton(target) {
    var btn = target.closest(ADD_SELECTOR);
    if (btn) return btn;
    var sub = target.closest('button[type="submit"], input[type="submit"], button:not([type])');
    if (sub && sub.form && /\/cart\/add/.test(sub.form.getAttribute('action') || '')) return sub;
    return null;
  }
  function onAdd(e) {
    var btn = addButton(e.target);
    if (!btn || btn.closest('.SmBulk')) return;
    var pid = readProductId(btn);
    var adding = readQty(btn);
    var total = cfg.mode === 'product' ? (pid ? productQty(pid) : 0) + adding : cart.item_count + adding;
    if (!isOver(total)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    go(total, pid);
  }
  document.addEventListener('click', onAdd, true);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var action = (form.getAttribute('action') || '').split('?')[0];
    if (/\/cart\/add$/.test(action)) {
      var qi = qtyInput(form.querySelector('[type="submit"], button') || form);
      var q = parseInt((qi || {}).value, 10) || 1;
      var total = (cfg.mode === 'product' ? productQty(cfg.productId) : cart.item_count) + q;
      if (isOver(total)) { e.preventDefault(); e.stopImmediatePropagation(); go(total, cfg.productId); }
    } else if (cfg.blockCheckout && /\/cart$/.test(action) && isOverCart()) {
      e.preventDefault(); e.stopImmediatePropagation(); go(cart.item_count);
    }
  }, true);

  /* 2. Block checkout when the cart is already over the limit */
  function isOverCart() {
    if (cfg.mode !== 'product') return isOver(cart.item_count);
    var byProduct = {};
    (cart.items || []).forEach(function (it) { byProduct[it.product_id] = (byProduct[it.product_id] || 0) + it.quantity; });
    return Object.keys(byProduct).some(function (k) { return isOver(byProduct[k]); });
  }
  if (cfg.blockCheckout) {
    document.addEventListener('click', function (e) {
      if (!e.target.closest(CHECKOUT_SELECTOR) || !isOverCart()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      go(cart.item_count);
    }, true);
  }

  /* 3. Safety net – watch every cart change (apps, drawer, cart page) */
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function afterChange() {
    var before = cart.item_count;
    refresh().then(function () {
      checkPayButtons();
      if (cfg.redirectAfter && cart.item_count > before && isOverCart()) go(cart.item_count);
    });
  }
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (CART_CHANGE.test(url)) p.then(function (r) { if (r.ok) afterChange(); return r; }).catch(function () {});
    return p;
  };
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_CHANGE.test(String(url))) {
      this.addEventListener('load', function () { if (this.status >= 200 && this.status < 300) afterChange(); });
    }
    return origOpen.apply(this, arguments);
  };

  /* Buy it now / Shop Pay live in an iframe – when the chosen quantity would go over the
     limit, cover them so the click lands on us and redirects instead. */
  function checkPayButtons() {
    document.querySelectorAll(PAY_SELECTOR).forEach(function (pay) {
      if (pay.parentElement && pay.parentElement.closest(PAY_SELECTOR)) return;
      var adding = readQty(pay);
      var pid = cfg.productId;
      var total = cfg.mode === 'product' ? productQty(pid) + adding : cart.item_count + adding;
      pay.classList.toggle('SmBulkLimit--over', isOver(total));
    });
  }
  var payTimer;
  function schedulePay() { clearTimeout(payTimer); payTimer = setTimeout(checkPayButtons, 60); }
  ['input', 'change', 'click', 'keyup'].forEach(function (ev) { document.addEventListener(ev, schedulePay, true); });
  var st = document.createElement('style');
  st.textContent = '.SmBulkLimit--over{position:relative!important}.SmBulkLimit--over>*{pointer-events:none!important}.SmBulkLimit--over::after{content:"";position:absolute;inset:0;z-index:5;cursor:pointer}';
  document.head.appendChild(st);

  /* Keep the cart in sync (other tabs, back button) */
  refresh().then(checkPayButtons);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh().then(checkPayButtons); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { redirecting = false; refresh(); } });
})();
